module.exports = __webpack_public_path__ + "img/vip_active.381bbb1b.png";